<template>
  <div class="home">
    <div class="banner">
      <img
        class="banner_img"
        src="../../static/img/home-banner.png"
        alt=""
      >
    </div>
    <div class="home_content max">
      <ul class="content w1200">
        <li v-for="(item,i) in content" :key="i" >
          <img :src="item.img" alt="">
          <h4>{{item.js}}</h4>
          <div class="jieshao">
            <p>{{item.text}}</p>
            <p>{{item.text1}}</p>
            <p class="slve">{{item.text2}}</p>
            <p>{{item.text3}}</p>
            <p class="slve">{{item.text4}}</p>
            <p>{{item.text5}}</p>
            <p class="slve">{{item.text6}}</p>
            <p>{{item.text7}}</p>
            <p class="slve">{{item.text8}}</p>
            <p>{{item.text9}}</p>

          </div>
          <span @click="$router.push({path:item.path}), skip(item.pages)" >了解更多</span>
        </li>
      </ul>
      <div class="hzhb w1200 ">
        <h4>合作伙伴</h4>
        <div class="hzimg">
          <img
            src="../../static/img/home_rb.png"
            alt=""
          >
          <img
            src="../../static/img/home_zh.png"
            alt=""
          >
          <img
            src="../../static/img/home_tp.png"
            alt=""
          >
          <img
            src="../../static/img/home_astp.png"
            alt=""
          >
          <img
            src="../../static/img/home_dh.png"
            alt=""
          >
          <img
            src="../../static/img/home_zj.png"
            alt=""
          >
          <img
            src="../../static/img/home_lb.png"
            alt=""
          >
          <img
            src="../../static/img/home_za.png"
            alt=""
          >

        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "",
  data() {
    return {
      content: [
        {
          js: "公司介绍",
          img: require("../../static/img/hone-gsjs.png"),
          text:
            "天津协和万邦保险经纪有限公司，成立于2008年，注册资本5000万，经营范围包括在全国区域内（港、澳、台除外）为投保人拟定投保方案、选择保险人、办理投保手......详情",
          path: '/introduction',
          pages: 1
        },
        // {
        //   js: "产品介绍",
        //   img: require("../../static/img/hone-cpjs.png"),
        //   text:"专业的移动车险服务",
        //   text1: '·方便  ·快捷  ·安全' ,
        //   path: '/product',
        //   pages: 2

        // },
        {
          js: "最新资讯",
          img: require("../../static/img/hone-zxzx.png"),
          text:"强强联手 新模式开...",   
          text1: '2018-12-05',
          text2:"弘扬真善美 传递正能量 公司开展学雷锋志愿服务活动",   
          text3: '2018-11-20',
          text4:"防范非法 集资小问答",   
          text5: '2018-09-18',
          text6:"公司组织 全体员工集中观看电影《厉害了，我的国",   
          text7: '2018-06-15',
          path: '/news',
          pages:  4
        }



        
      ]
    };
  },
  mounted() {
  },
  methods: {
    skip(i) {
      this.bus.$emit('pages', {pages: i})
      sessionStorage.setItem('pages', 1)
      // console.log(i)
    }
  }
};
</script>

<style  lang="scss" scoped>
.home_content {
  background-color: #f4f4f4;
  overflow: hidden;
  .content {
    padding: 60px 145px;
    background-color: #fff;
    min-height: 570px;
    display: flex;
    justify-content: space-between;
    li {
      width: 380px;
      color: #3c3c3c;
      h4 {
        text-align: center;
        padding: 25px 0 30px 0;
        color: #383838;
        font-weight: 600;
        font-size: 24px;
      }
      .jieshao{
        min-height: 140px;
        width: 365px;
        padding-bottom: 30px;
          p {
            font-size: 18px;
            line-height: 30px;
          }
          .slve{
              width:165px;
              overflow: hidden;
              white-space: nowrap;
              text-overflow:ellipsis;
          }

      }
      span {
        display: block;
        width: 145px;
        height: 50px;
        line-height: 50px;
        text-align: center;
        border: 2px solid #dcdcdc;
        border-radius: 30px;
        left: 50%;
        cursor: pointer;
        // transition: all 1s;
        margin: 0 auto;
      }
      span:hover{
        color: #5182c4;
        border: 2px solid #5182c4;
        transition: all 1s;
      }
    }
    li:nth-child(2) .jieshao{
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      align-items: center;
      p {
        margin: 0;
        line-height: 36px;
      }
      .slve {
        flex: 0 0 240px;
        font-size: 16px;
        color: #3c3c3c;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
      p:first-child {
        flex: 0 0 240px;
        font-size: 16px;
        color: #3c3c3c;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
      p:not(.slve):not(:first-child) {
        flex: 0 0 auto;
        font-size: 14px;
        color: #999;
        text-align: right;
      }
    }
  }
  .hzhb {
    height: 450px;
    margin-top: 60px;
    background-color: #fff;
    h4 {
      padding: 30px 0 30px 20px;
      border-bottom: 3px solid #cecece;
      margin-bottom: 30px;
    }
    .hzimg {
      padding: 13px 40px;
      width: 100%;
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      img {
        margin-top: 30px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Home.vue